import { IconButton, InputAdornment, TextFieldProps } from '@mui/material';
import { NiaraIcon } from '@niaratech/niara-icons';
import React from 'react';
import InputText, { InputTextProps } from '../InputText';
export type InputPlaceholderProps = InputTextProps & {
  value?: string;
  TextFieldProps?: Pick<TextFieldProps, 'inputProps' | 'InputProps' | 'variant'>;
  hideLabel?: boolean;
  labelVariant?: 'notched';
  size?: 'medium' | 'small';
  fullWidth?: boolean;
  startAdornment?: React.ReactElement | string;
  onClickEdit?: () => void;
};
const InputPlaceholder: React.FC<InputPlaceholderProps> = ({
  value,
  TextFieldProps,
  label,
  hideLabel,
  labelVariant,
  size,
  fullWidth,
  startAdornment,
  onClickEdit
}) => {
  const selectedProps = {
    value,
    TextFieldProps,
    label,
    hideLabel,
    labelVariant,
    size,
    fullWidth,
    startAdornment
  };
  return <InputText {...selectedProps} endAdornment={<InputAdornment position="end">
          <IconButton aria-label="edit placeholderValue" onClick={onClickEdit} edge="end">
            <NiaraIcon icon="sysPencil" />
          </IconButton>
        </InputAdornment>} readOnly={true} />;
};
export default InputPlaceholder;